module.exports = __webpack_public_path__ + "static/selected-language-mobile@2x-9b63accc92aeec5a5a11a9a949b3d562.png";